import { Flex, FormControl, FormLabel, Radio, RadioGroup, Stack, Text, useToast } from '@chakra-ui/react'
import { useState, useEffect } from 'react'
import { FaAngleLeft, FaWrench } from 'react-icons/fa'
import { useNavigate, useParams } from 'react-router-dom'
import { ButtonCmp } from '../../../components/ButtonCmp'
import { CreateEtapaBox } from '../../../components/CreateEtapaBox'
import { EditorTexto } from '../../../components/EditorTexto/Index'
import { WhiteContainer } from '../../../components/WhiteContainer'
import { iEtapa } from '../../../interfaces'
import { appApi } from '../../../services/appApi'
import { ValidarEtapa } from '../../../Utils/Helper'
import { Body } from '../../Layouts/Body'

interface iModel {
  tipoResponsavel: number
  textoCriacao: string
}

export const EtapaPDI: React.FC = () => {
  const toast = useToast()
  const nav = useNavigate()
  const { trilhaId, etapaId, processoId } = useParams<{ trilhaId: string, etapaId: string, processoId: string }>()
  const [Model, setModel] = useState<iModel>({
    tipoResponsavel: 0,
    textoCriacao: ''
  })

  const [Etapa, setEtapa] = useState<iEtapa>({})
  const [IsLoading, setIsLoading] = useState(false)

  function CriarEtapa(): void {
    const url = trilhaId ? `PDIEtapa/${trilhaId}` : processoId ? `PDIEtapaColaborador/${processoId}` : ''

    if (!ValidarEtapa(Etapa)) {
      toast({
        title: 'Preencha os campos de etapa',
        status: 'error',
        isClosable: false,
        position: 'top-right',
        duration: 4000
      })
      return
    }
    appApi.post(url, {
      etapa: Etapa,
      pdi: Model
    })
      .then(() => {
        toast({
          title: 'Etapa criada com sucesso',
          status: 'success',
          isClosable: false,
          position: 'top-right',
          duration: 4000
        })
        nav(-1)
      })
      .catch(res => console.log(res))
  }

  function AtualizarEtapa(enviarEmail: boolean): void {
    const url = trilhaId ? `PDIEtapa/${etapaId ?? ''}` : processoId ? `PDIEtapaColaborador/${processoId}/Etapa/${etapaId ?? ''}?enviarEmail=${enviarEmail}` : ''
    if (!ValidarEtapa(Etapa)) {
      toast({
        title: 'Preencha os campos de etapa',
        status: 'error',
        isClosable: false,
        position: 'top-right',
        duration: 4000
      })
      return
    }
    appApi.put(url, {
      etapa: Etapa,
      pdi: Model
    })
      .then(() => {
        toast({
          title: 'Etapa atualizada com sucesso',
          status: 'success',
          isClosable: false,
          position: 'top-right',
          duration: 4000
        })
        nav(-1)
      })
      .catch(res => console.log(res))
  }

  function ObterEtapa(): void {
    const url = trilhaId ? `PDIEtapa/${etapaId ?? ''}` : processoId ? `PDIEtapaColaborador/${processoId}/Etapa/${etapaId ?? ''}` : ''

    appApi.get(url)
      .then(res => {
        setEtapa(res.data.etapa)
        setIsLoading(true)
        setModel(res.data.pdi)
        setTimeout(() => setIsLoading(false), 1000)
      })
      .catch(err => console.log(err))
  }

  function ResetTextoPadrao(): void {
    const texto = '<p><strong>Olá, [NOME DO RESPONSAVEL]!<br><br>A pesquisa do(a) [NOME DO AVALIADO] foi concluída e você já pode iniciar o cadastro do PDI para o desenvolvimento dele!<br><br>É muito simples, basta acessa o link com os resultados do avaliado e Clicar no botão “Adicionar PDI”, criar as ações especificando o que, por que e como ele deve trabalhar cada uma das competências definidas.<br><br>Você tem até o dia [DATA FIM] para cadastrar o PDI.<br><br>Link dos resultados da pesquisa do(a) [NOME DO AVALIADO]:<br><br>[LINK]<br><br><br>Se tiver qualquer dúvida pode entrar em contato com nosso RH.<br><br>Atenciosamente,<br>Equipe [NOME DA EMPRESA] </strong></p>'
    setIsLoading(true)
    setModel({ ...Model, textoCriacao: texto })
    setTimeout(() => setIsLoading(false), 1000)
  }

  useEffect(() => {
    if (etapaId) {
      ObterEtapa()
    } else {
      ResetTextoPadrao()
    }
  }, [])

  return (
        <Body>
            <Flex>
                <h1>PDI</h1>
            </Flex>
            <WhiteContainer margin='1rem 0'>
                <h3>Configuração da etapa</h3>
                <FormControl>
                    <FormLabel color={'var(--Gray1)'} fontSize={'14px'} mt={'.75rem'} mb={0}>Quem irá inserir o PDI do colaborador?</FormLabel>
                    <Text color={'var(--Gray3)'} fontSize={'.813rem'}>Essa pessoa receberá um e-mail para subir o PDI assim que os resultados forem liberados</Text>
                    <RadioGroup
                        margin={'.325rem'}
                        mb={'.75rem'}
                        value={Model?.tipoResponsavel.toString()}
                        size={'sm'}
                        onChange={(e) => setModel({ ...Model, tipoResponsavel: parseInt(e) })}
                    >
                        <Stack gap={'.75rem'} direction={'row'}>
                            <Radio borderColor={'var(--Gray4)'} value={'0'}>Gestor</Radio>
                            <Radio borderColor={'var(--Gray4)'} value={'1'}>Colaborador</Radio>
                            <Radio borderColor={'var(--Gray4)'} value={'2'}>RH</Radio>
                        </Stack>
                    </RadioGroup>
                    <CreateEtapaBox
                        variant='Etapa'
                        keyWord='PDI'
                        EditEtapa={Etapa}
                        onModelChange={(e) => setEtapa(e)}
                        isPdi
                    />
                </FormControl>
            </WhiteContainer>

            <WhiteContainer margin='0 0 1rem 0rem'>
                <Flex justifyContent={'space-between'}>
                    <div style={{ maxWidth: '55rem' }}>
                        <h3>Texto para criação do PDI</h3>
                        <Text fontWeight={'500'} fontSize='0.875rem' mb={'.5rem'}>Esse é o texto que será enviado ao e-mail do responsável por subir o PDI do colaborador</Text>
                    </div>
                </Flex>

                <EditorTexto
                    isLoading={IsLoading}
                    initialValue={Model.textoCriacao}
                    onChange={(e: string) => setModel({ ...Model, textoCriacao: e })}
                />
                <Flex marginTop='1rem' justifyContent={'start'} gap={'.75rem'}>
                    <Flex gap={'.5rem'}>
                        <ButtonCmp
                            VarColor={'c6'}
                            leftIcon={<FaWrench />}
                            onClick={() => ResetTextoPadrao()}
                        >Restaurar texto padrão</ButtonCmp>
                    </Flex>
                </Flex>
            </WhiteContainer>
            <Flex gap={'.5rem'} justifyContent={'end'}>
                <ButtonCmp VarColor='c6' onClick={() => nav(-1)} leftIcon={<FaAngleLeft />}>Voltar</ButtonCmp>
                {!etapaId && <ButtonCmp VarColor='Green2' onClick={CriarEtapa}>Criar etapa</ButtonCmp>}
                {etapaId && <ButtonCmp VarColor='Rosa' onClick={() => AtualizarEtapa(true)}>Atualizar etapa e reenviar convite</ButtonCmp>}
                {etapaId && <ButtonCmp VarColor='Green2' onClick={() => AtualizarEtapa(false)}>Atualizar etapa</ButtonCmp>}
            </Flex>
        </Body>
  )
}
